import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCart = create(
  persist(
    (set, get) => ({
      cart: [],
      addItem: (product) => {
        const cart = get().cart;
        const existing = cart.find((cart_product) => cart_product.id === product.id);
        if (existing) {
          set({
            cart: cart.map((cart_product) =>
              cart_product.id === product.id ? { ...cart_product, quantity: cart_product.quantity + 1 } : cart_product
            ),
          });
        } else {
          set({ cart: [...cart, { ...product, quantity: 1 }] });
        }
      },
      increaseQuantity: (id) => {
        set({
          cart: get().cart.map((cart_product) =>
            cart_product.id === id ? { ...cart_product, quantity: cart_product.quantity + 1 } : cart_product
          ),
        });
      },
      reduceQuantity: (id) => {
        const cart = get().cart;
        const updatedCart = cart
          .map((cart_product) =>
            cart_product.id === id
              ? { ...cart_product, quantity: cart_product.quantity - 1 }
              : cart_product
          )
          .filter((cart_product) => cart_product.quantity > 0);

        set({ cart: updatedCart });
      },
      removeItem: (id) => {
        set({ cart: get().cart.filter((cart_product) => cart_product.id !== id) });
      },
      clearCart: () => set({ cart: [] }),
    }),
    { name: 'cart-storage' }
  )
);

export default useCart;
